import React from "react";
import HeaderWithSidebar from "./header/HeaderWithSidebar";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Loader from "../loader/Loader";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/features/store/store";

const Layout = () => {
  const isLoginLoading = useSelector((state: RootState) => state.login.isLoginLoading);

  return (
    <>
      <HeaderWithSidebar />
      <Box
        component="main"
        className="content"
        sx={{ width: "100%", flexGrow: 1, p: { xs: 2, sm: 2 } }}
      >
        {isLoginLoading ? <Loader isLoading={isLoginLoading} /> : <Outlet />}
      </Box>
    </>
  );
};

export default Layout;
